/** `podmanDeployTarget` — the shared container runtime bound to the `podman` bin. */

import { makeContainerDeployTarget } from "./container-runtime.js";

export const podmanDeployTarget = makeContainerDeployTarget("podman");
